import script from "./Collections.vue?vue&type=script&setup=true&lang=js"
export * from "./Collections.vue?vue&type=script&setup=true&lang=js"

import "./Collections.vue?vue&type=style&index=0&id=83044b6c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83044b6c"]])

export default __exports__